import strings from 'utils/strings'
import { ACTIVE, TEST, NEW, RETURNED } from 'utils/constants'
import { mapFrom } from 'utils/functional'

const statuses = {
  [ACTIVE]: strings.active,
  [TEST]: strings.test,
  [NEW]: strings.feature_status_new,
  [RETURNED]: strings.feature_status_returned,
}

export default mapFrom(statuses)
